import Actor from "../../assets/Images/for-employers/actors-main.png";
import Voiceover from "../../assets/Images/for-employers/voiceover-artist.png";
import Singer from "../../assets/Images/for-employers/singers.png";
import Dancer from "../../assets/Images/for-employers/dancers.png";
import Talent from "../../assets/Images/for-employers/talent.png";
import ChildActor from "../../assets/Images/for-employers/child-actor.png";
import Entertainers from "../../assets/Images/for-employers/entertainers.png";
import FilmTV from "../../assets/Images/for-employers/film-tv-production.png";
import Theatre from "../../assets/Images/for-employers/theatre.png";
import Music from "../../assets/Images/for-employers/music-professional.png";

export const actorData = {
  heroHeading: "Are you an Actor Looking for Jobs?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Acting Jobs and Auditions Across the UK",
  heroImg: Actor,
  btnHead: "Find The Acting Roles That Are Right For You",
  btnData: [
    "Commercial",
    "Computer Game",
    "Corporate Role Play",
    "Cruise Ship",
    "Documentary",
    "Film",
    "Music Video",
    "Musical Theatre",
    "Online",
    "Presenter",
    "Radio",
    "Rehearsed Reading",
    "Role Play",
    "Drama",
    "Stage",
    "Screen",
    "Web Series",
    "Devised Theatre",
  ],
};

export const voiceoverData = {
  heroHeading: "Are You a Voiceover Artist Looking For a Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Voiceover Jobs and Auditions Across the UK",
  heroImg: Voiceover,
  btnHead: "Find The Voiceover Roles That Are Right For You",
  btnSubHead:
    "We let you find voiceover jobs to suit your voiceover specialism! We list voiceover artist jobs in the UK of the following types:",
  btnData: [
    "Animation",
    "Cartoons",
    "Audiobook",
    "Coaching",
    "Commercials",
    "Game",
    "Documentary",
    "Dubbing",
    "E-Learning",
    "Events",
    "Film",
    "Navigation",
    "Internet",
    "Jingles",
    "Languages",
    "Lip Sync",
    "Multimedia",
    "Narration",
    "News",
    "Podcast",
    "Radio",
    "Spoken Word",
    "Performance Poetry",
    "Sports",
    "Telephony",
    "TV",
    "Theatre",
    "Translation",
  ],
};

export const singerData = {
  heroHeading: "Are you a Singer Looking for Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Singing Jobs and Auditions Across the UK",
  heroImg: Singer,
  btnHead: "Find The Singing Roles That Are Right For You",
  btnSubHead:
    "We let you find voiceover jobs to suit your singing specialism! We list voiceover artist jobs in the UK of the following types:",
  btnData: [
    "Backing-Vocalist",
    "Choral",
    "Corporate",
    "Coaching",
    "Film",
    "Holiday Entertainment",
    "Lead Vocalist",
    "Dubbing",
    "Musical",
    "Opera",
    "Session",
    "Navigation",
    "Song Writer",
    "Studio Manager",
    "Teacher",
    "Lip Sync",
    "Theatre",
  ],
};

export const dancerData = {
  heroHeading: "Are you a Dancer Looking For a Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Dancing Jobs and Auditions Across the UK",
  heroImg: Dancer,
  btnHead: "Find The Dancing Roles That Are Right For You",
  btnSubHead:
    "We let you find voiceover jobs to suit your dancing specialism! We list dancer jobs in the UK of the following types:",
  btnData: [
    "Backing",
    "Cabaret",
    "Choreography",
    "Circus",
    "Commercial",
    "Company",
    "Competition",
    "Cruise-ship",
    "Events",
    "Film",
    "Holiday Entertainment",
    "Music Video",
    "Musical",
    "Pantomime",
    "Photoshoot",
    "Teacher",
    "Theatre",
    "Tour",
  ],
};

export const talentData = {
  heroHeading: "Are you a Artist Looking For a Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Artist Jobs and Auditions Across the UK",
  heroImg: Talent,
  btnHead: "Find The Talent Roles That Are Right For You",
  btnSubHead:
    "We let you find Talent jobs to suit your Talent specialism! We list Talent jobs in the UK of the following types:",
  btnData: [
    "Game Show",
    "Quiz Show",
    "TV Extra",
    "Film Extra",
    "Modelling",
    "Radio",
    "Still Photos",
  ],
};

export const childActorData = {
  heroHeading: "Are you Looking for a Job for your baby Actor?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Acting Jobs and Auditions Across the UK",
  heroImg: ChildActor,
  btnHead: "Find The Acting Roles That Are Right For You",
  btnData: [
    "Commercial",
    "Computer Game",
    "Corporate Role Play",
    "Cruise Ship",
    "Documentary",
    "Film",
    "Music Video",
    "Music Theatre",
    "Online",
    "Presenter",
    "Radio",
    "Rehearsed Reading",
    "Role play",
    "Drama",
    "Stage",
    "Screen",
    "Web Series",
    "Devised Theatre",
  ],
};

export const entertainerData = {
  heroHeading: "Are you Looking for an Entertainment Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Entertainment Jobs and Auditions Across the UK",
  heroImg: Entertainers,
  btnHead: "Find The Entertainment That Are Right For You",
  btnSubHead:
    "We let you find Talent jobs to suit your entertainment specialism! We list entertainer jobs in the UK of the following types:",
  btnData: [
    "Bar",
    "Club",
    "Charity Event",
    "Children’s Party",
    "Corporate Event",
    "Party",
    "Private Event",
    "Public Sector Event",
    "Theatre",
    "Wedding",
  ],
};

export const filmTvData = {
  heroHeading: "Are you Looking for a Crew Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Crew Jobs and Auditions Across the UK",
  heroImg: FilmTV,
  btnHead: "Find The Crew Jobs That Are Right For You",
  btnSubHead:
    "We let you find Talent jobs to suit your Crew specialism! We list Crew jobs in the UK of the following types:",
  btnData: [
    "Animation",
    "Documentary",
    "Film",
    "Live Event",
    "Music Video",
    "Radio",
    "Theatre",
    "TV",
    "Video Game",
  ],
};

export const theatreData = {
  heroHeading: "Are you Looking for a Theatre Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Theatre Jobs and Auditions Across the UK",
  heroImg: Theatre,
  btnHead: "Find The Theatrical Jobs That Are Right For You",
  btnSubHead:
    "We let you find Talent jobs to suit your Theatrical specialism! We list Theatre jobs in the UK of the following types:",
  btnData: [
    "Administrator",
    "Technical Cruise",
    "Theatre",
    "Exhibition",
    "Exhibition",
    "Music",
    "Opera",
    "TV",
    "Front of House",
    "Ticketing",
    "Tour",
    "Lifters",
    "Worship",
  ],
};

export const musicData = {
  heroHeading: "Are you Looking for a Music Job?",
  heroSubHead:
    "Be a part of the Squad Apply to the Latest Music Jobs and Auditions Across the UK",
  heroImg: Music,
  btnHead: "Find The Music Jobs That Are Right For You",
  btnSubHead:
    "We let you find Talent jobs to suit your music specialism! We list music jobs in the UK of the following types:",
  btnData: [
    "A&amp;R",
    "Administrator",
    "Arranging",
    "Artist Management",
    "Audio Mixer",
    "Choir",
    "Composing",
    "Concert Promoting",
    "Conductor",
    "DJ",
    "Band",
    "Education",
    "Festival",
    "Head of Music",
    "Live Performance",
    "Direction",
    "Editor",
    "Entertainer",
    "Journalism",
    "Leader",
    "Library",
    "Marketing",
    "Production",
    "Research",
    "Therapy",
    "Video",
    "Musician",
    "Opera",
    "Orchestra",
    "Programing Arts",
    "Personal Manager",
    "Engineering",
    "Professor",
    "Publicity",
    "Publishing",
    "Recording Engineer",
    "Recording Group",
    "Repetiteur",
    "Research",
    "Session Musician",
    "Song Writer",
    "Sound Design",
    "Studios",
    "Teacher",
    "Tour",
    "Tour Manager",
    "Venue",
  ],
};
